import {useQuery} from "@tanstack/react-query";
import {queryKeys} from "../react-query/constant";
import {HypoInfoListApi} from "../api/hypo";

export const useHypoList = (patientId,daysAgo) => {
    const fetchData = HypoInfoListApi();
    return useQuery(
        [queryKeys.hypoList, daysAgo,patientId],
        () => fetchData(patientId,daysAgo),
    );
};